import { RegModalProviders } from '@/components/_promo/components/RegModalProviders';
import type { RegistrationConfig } from '../types';
import { DARKLE_REG_CONFIG } from './darkle';

export const DARKLE_REG_PROVIDERS_CONFIG: RegistrationConfig = {
  ...DARKLE_REG_CONFIG,
  hideSteps: true,
  customBottomBlock: {
    render: () => <RegModalProviders />,
  },
};
